import React from 'react';
import Wave from '@/components/elements/wave';

export default function MdxWave({ children }) {
	return (
		<div className="mdx-wave">
			<Wave fillColor="MARINER_EXTRA_LIGHT" />
			<div className="bg-mariner-extra-light">
				<div className="container pb-10 pt-20">{children}</div>
			</div>
			<Wave backgroundColor="MARINER_EXTRA_LIGHT" />
		</div>
	);
}
